import {DiscountGenqlSelection} from "@/gql/gen";

export const DiscountFields: DiscountGenqlSelection = {
    ID: true,
    NAME: true,
    ACTIVE: true,
    CODE: true,
    PREVIEW_TEXT: true,
    DISCOUNT_PERCENT: true,
    DISCOUNT_TARGET: true,
    CONDITION: {
       __fragment: 'OrderCondition'
    },
    SORT: true,
}
